export enum ProfileType {
    User,
    Investor,
    Company,
    Founder,
    TeamMember,
    Pitch,
    TermsAndConditions
}